var IcuUnits = {
    miles: "mile",
    km: "kilometer",
    m: "meter",
    mi: "mile",
};
export var icuDistanceUnits = function (unit) {
    if (unit === null || unit === undefined)
        return unit;
    return IcuUnits[unit.toLocaleLowerCase()] || unit;
};
